import {
  useQuery,
  QueryResult,
  QueryOptions,
  WatchQueryFetchPolicy,
} from '@apollo/client';
// Api
import { GET_AUDIENCE_FILTERS } from 'api/campaignV2/queries';
// Types
import { GetAudienceFilters } from 'api/campaignV2/types/GetAudienceFilters';

type BasicQueryOptions = Omit<
  QueryOptions,
  'query' | 'variables' | 'fetchPolicy'
> & {
  fetchPolicy?: WatchQueryFetchPolicy;
};

type UseGetAudienceFiltersOptions = {
  options?: BasicQueryOptions;
};

export const useGetAudienceFilters = (
  options?: UseGetAudienceFiltersOptions
): QueryResult<GetAudienceFilters> => {
  const audienceFilters = useQuery<GetAudienceFilters>(GET_AUDIENCE_FILTERS, {
    ...options?.options,
  });

  return audienceFilters;
};
